import { render, staticRenderFns } from "./OrganizationGroupsField.vue?vue&type=template&id=1cc02c91"
import script from "./OrganizationGroupsField.vue?vue&type=script&lang=js"
export * from "./OrganizationGroupsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports